import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import NotFound from "@/pages/not-found";
import Home from "@/pages/home";
import Watch from "@/pages/watch";
import AdminVideos from "@/pages/admin/videos";
import AdminUsers from "@/pages/admin/users";
import AdminPuzzles from "@/pages/admin/puzzles";
import AdminFAQ from "@/pages/admin/faq";
import AdminCodes from "@/pages/admin/codes";
import AdminStats from "@/pages/admin/stats";
import Auth from "@/pages/auth";
import Profile from "@/pages/profile";
import UserProfile from "@/pages/UserProfile";
import Deposits from "@/pages/deposits";
import CacataisTransactions from "@/pages/cacatais-transactions";
import Coins from "@/pages/coins";
import Pool from "@/pages/pool/index";
import Puzzles from "@/pages/puzzles/index";
import Puzzle from "@/pages/puzzles/detail";
import CustomPuzzle from "@/pages/puzzles/custom";
import CustomPuzzleHints from "@/pages/puzzles/[id]/hints";
import Privacy from "@/pages/privacy";
import Rank from "@/pages/pool/rank";
import PuzzlesRank from "@/pages/puzzles/rank";
import Cacatal from "@/pages/cacatal/index";
import YouTubeCallback from "@/pages/youtube-callback";
import FAQ from "@/pages/faq/index";
import Footer from "@/components/footer";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { SolanaProvider } from "@/components/solana-provider";
import CreatePuzzles from "@/pages/puzzles/create";
import EditPuzzlePage from "@/pages/puzzles/edit";
import DiscussionPage from "@/pages/puzzles/discussion";
import DesafiosCacatais from "@/pages/desafios-cacatais";
import CreateCodePage from "@/pages/codes/create";
import CodesPage from "@/pages/codes";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/watch/:videoId" component={Watch} />
      <Route path="/admin/videos" component={AdminVideos} />
      <Route path="/admin/users" component={AdminUsers} />
      <Route path="/admin/puzzles" component={AdminPuzzles} />
      <Route path="/admin/faq" component={AdminFAQ} />
      <Route path="/admin/codes" component={AdminCodes} />
      <Route path="/admin/stats" component={AdminStats} />
      <Route path="/auth" component={Auth} />
      <Route path="/profile" component={Profile} />
      <Route path="/users/:displayName" component={UserProfile} />
      <Route path="/deposits" component={Deposits} />
      <Route path="/cacatais-transactions" component={CacataisTransactions} />
      <Route path="/coins" component={Coins} />
      <Route path="/pool" component={Pool} />
      <Route path="/puzzles" component={Puzzles} />
      <Route path="/puzzles/create" component={CreatePuzzles} />
      <Route path="/puzzles/edit/:id" component={EditPuzzlePage} />
      <Route path="/puzzles/discussion" component={DiscussionPage} />
      <Route path="/puzzles/detail/:id" component={Puzzle} />
      <Route path="/puzzles/custom/:id" component={CustomPuzzle} />
      <Route path="/puzzles/custom/:id/hints" component={CustomPuzzleHints} />
      <Route path="/codes" component={CodesPage} />
      <Route path="/codes/create" component={CreateCodePage} />
      <Route path="/privacy" component={Privacy} />
      <Route path="/pool/rank" component={Rank} />
      <Route path="/puzzles/rank" component={PuzzlesRank} />
      <Route path="/cacatal" component={Cacatal} />
      <Route path="/desafios-cacatais" component={DesafiosCacatais} />
      <Route path="/faq" component={FAQ} />
      <Route path="/auth/youtube/callback" component={YouTubeCallback} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <LanguageProvider>
      <QueryClientProvider client={queryClient}>
        <SolanaProvider>
          <div className="min-h-screen flex flex-col bg-black">
            <Router />
            <Footer />
            <Toaster />
          </div>
        </SolanaProvider>
      </QueryClientProvider>
    </LanguageProvider>
  );
}

export default App;